import React from "react";

const ErrorPage = () => {
  return (
    <div className="h-75 py-5">
      <h1 className="text-center py-5">Page Not Found</h1>
    </div>
  );
};

export default ErrorPage;
